module.exports = __webpack_public_path__ + "static/wl_header_video_uk-4e3876d270edf895c0aba64426acb170.mp4";